import React from "react";
import { useQuery } from "react-query";
import { getItemizedDetailsHistoryById } from "../../../../actions/CarrierAgreementMgmt/VendorInvoice";

const useGetItemizeHistoryByInvoiceHistoryId = (invoiceHistoryId) => {
  return useQuery(
    ["GetItemizedDetailsById", invoiceHistoryId],
    () => getItemizedDetailsHistoryById(invoiceHistoryId),
    {
      refetchOnWindowFocus: false,
    }
  );
};

export default useGetItemizeHistoryByInvoiceHistoryId;
